import React, { useState, useEffect } from "react";
import {
    Container, Card, Button, Modal, Form, Alert
} from "react-bootstrap";

import { useDispatch, useSelector } from "react-redux";
import { getBankDetails, addBankDetails, editBankDetails, deleteBankDetails } from "../../store/slices/user";

import { TbEdit } from "react-icons/tb";
import { PiTrashSimpleFill } from "react-icons/pi";
import { Link } from "react-router-dom";


export default function BankAccount() {
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const [editingId, setEditingId] =

        useState(null);
    const { bankDetails } =
        useSelector(
            (state) => state.user
        );

    const [showModal, setShowModal] =
        useState(false);

    const [formData, setFormData] =
        useState({
            accountHolderName: "",
            bankName: "",
            accountNumber: "",
            ifscCode: "",
            accountType: "Savings",
        });

    useEffect(() => {
        dispatch(getBankDetails());
    }, [dispatch]);

    const validateForm = () => {
        const newErrors = {};

        if (!formData.accountHolderName?.trim()) {
            newErrors.accountHolderName =
                "Please enter account holder name ";
        } else if (
            !/^[A-Za-z\s.]+$/.test(
                formData.accountHolderName
            )
        ) {
            newErrors.accountHolderName =
                "Only letters are allowed";
        }

        if (!formData.bankName?.trim()) {
            newErrors.bankName =
                "Please enter  bank name";
        }

        if (!formData.accountNumber?.trim()) {
            newErrors.accountNumber =
                "Please enter account number";
        } else if (
            !/^\d{9,18}$/.test(
                formData.accountNumber
            )
        ) {
            newErrors.accountNumber =
                "Account number must be 9-18 digits";
        }

        if (!formData.ifscCode?.trim()) {
            newErrors.ifscCode =
                " Please enter IFSC code";
        } else if (
            !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(
                formData.ifscCode.toUpperCase()
            )
        ) {
            newErrors.ifscCode =
                "Invalid IFSC code";
        }

        if (
            formData.upiId &&
            !/^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/.test(
                formData.upiId
            )
        ) {
            newErrors.upiId =
                "Invalid UPI ID";
        }

        setErrors(newErrors);

        return Object.keys(newErrors)
            .length === 0;
    };

    const handleFieldChange = (
        field,
        value
    ) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));

        let error = "";

        switch (field) {
            case "accountHolderName":
                if (!value.trim()) {
                    error =
                        "Please enter account holder name";
                } else if (
                    !/^[A-Za-z\s.]+$/.test(value)
                ) {
                    error =
                        "Only letters are allowed";
                }
                break;

            case "bankName":
                if (!value.trim()) {
                    error =
                        " Please enter bank name ";
                }
                break;

            case "accountNumber":
                if (!value.trim()) {
                    error =
                        "Please enter account number";
                } else if (
                    !/^\d+$/.test(value)
                ) {
                    error =
                        "Account number must contain only digits";
                } else if (
                    value.length < 9 ||
                    value.length > 18
                ) {
                    error =
                        "Account number must be between 9 and 18 digits";
                }
                break;

            case "ifscCode":
                if (!value.trim()) {
                    error =
                        "Please enter IFSC code";
                } else if (
                    !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(
                        value.toUpperCase()
                    )
                ) {
                    error =
                        "Invalid IFSC code (e.g. SBIN0001234)";
                }
                break;

            default:
                break;
        }

        setErrors((prev) => ({
            ...prev,
            [field]: error,
        }));
    };
    const handleSubmit = async () => {

        if (!validateForm()) {
            return;
        }

        const result = editingId
            ? await dispatch(
                editBankDetails({
                    id: editingId,
                    ...formData,
                })
            )
            : await dispatch(
                addBankDetails(formData)
            );

        if (
            addBankDetails.fulfilled.match(result) ||
            editBankDetails.fulfilled.match(result)
        ) {
            setShowModal(false);

            setEditingId(null);

            dispatch(getBankDetails());
        }
    };

    const handleDelete = async (
        id
    ) => {
        if (
            !window.confirm(
                "Delete this bank account?"
            )
        ) {
            return;
        }

        await dispatch(
            deleteBankDetails(id)
        );

        dispatch(getBankDetails());
    };

    return (

        <>


            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/user/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"

                            >
                                Bank Account
                            </span>
                        </div>

                        <button
                            className="add-outlet-btn"
                            onClick={() => {

                                setEditingId(null);

                                setFormData({
                                    accountHolderName: "",
                                    bankName: "",
                                    accountNumber: "",
                                    ifscCode: "",
                                    accountType: "Savings",
                                });

                                setShowModal(true);
                            }}
                        >

                            Add Bank Account
                        </button>

                    </div>
                </div>
            </div>


            <div className="bg-white">

                <Container fluid>
                    <div className="global-header-card">

                        <div>

                            <h2 className="team-title">
                                Bank Account Details
                            </h2>
                        </div>
                    </div>

                    <div className="table-responsive">

                        {bankDetails?.length > 0 ? (
                            <Card>
                                <Card.Body>
                                    <>
                                        {bankDetails.map((item, idx) => (
                                            <Card

                                                key={item._id}
                                                className="card-body-bnk mb-4"

                                            >
                                                <Card.Body>

                                                    <div className="d-flex gap-2 justify-content-between mb-3">

                                                        <div className="cancel-btn-bnk" style={{ background: "#0F172A", boxShadow: "none" }}>
                                                            {idx + 1}
                                                        </div>

                                                        <div className="d-flex flex-row gap-1">
                                                            {!item.isVerified && (
                                                                <button
                                                                    className="edit-btn-bnk"
                                                                    onClick={() => {
                                                                        setEditingId(item._id);

                                                                        setFormData({
                                                                            accountHolderName:
                                                                                item.accountHolderName,
                                                                            bankName:
                                                                                item.bankName,
                                                                            accountNumber:
                                                                                item.accountNumber,
                                                                            ifscCode:
                                                                                item.ifscCode,
                                                                            accountType:
                                                                                item.accountType,
                                                                        });

                                                                        setShowModal(true);
                                                                    }}
                                                                >
                                                                    <TbEdit />
                                                                </button>
                                                            )}

                                                            <button

                                                                onClick={() =>
                                                                    handleDelete(item._id)
                                                                }
                                                                className="cancel-btn-bnk"
                                                            >
                                                                <PiTrashSimpleFill />
                                                            </button>
                                                        </div>

                                                    </div>

                                                    <div className="row g-3">

                                                        <div className="col-md-4">
                                                            <div className="detail-field">
                                                                <span className="detail-label">Account Holder</span>
                                                                <p className="detail-value">{item.accountHolderName}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="detail-field">
                                                                <span className="detail-label">Bank Name</span>
                                                                <p className="detail-value">{item.bankName}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="detail-field">
                                                                <span className="detail-label">Account Number</span>
                                                                <p className="detail-value">{item.accountNumber}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="detail-field">
                                                                <span className="detail-label">IFSC Code</span>
                                                                <p className="detail-value">{item.ifscCode}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="detail-field">
                                                                <span className="detail-label">Account Type</span>
                                                                <p className="detail-value">{item.accountType}</p>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-4">
                                                            <div className="detail-field">
                                                                <span className="detail-label">Status</span>
                                                                <p className="detail-value">
                                                                    {item.isVerified ? (
                                                                        <span
                                                                            className="badge rounded-pill"
                                                                            style={{
                                                                                background: "#d4edda",
                                                                                color: "#155724"
                                                                            }}
                                                                        >
                                                                            Verified
                                                                        </span>
                                                                    ) : (
                                                                        <span
                                                                            className="badge rounded-pill"
                                                                            style={{
                                                                                background: "#fff3cd",
                                                                                color: "#856404"
                                                                            }}
                                                                        >
                                                                            Pending Verification
                                                                        </span>
                                                                    )}
                                                                </p>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </Card.Body>
                                            </Card>
                                        ))}
                                    </>
                                </Card.Body>
                            </Card>
                        ) : (
                            <Alert variant="info">
                                No bank account added.
                            </Alert>
                        )}
                    </div>
                </Container>
                <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    centered
                    className="bam-modal"
                >
                    <Modal.Header closeButton className="bam-header">
                        <Modal.Title className="bam-title" style={{ color: "#fff" }}>
                            Bank Account Details
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body className="bam-body">
                        <Form.Group className="mb-1 bam-field">
                            <Form.Label className="bam-label">
                                Account Holder Name
                            </Form.Label>

                            <Form.Control
                                className="bam-input"
                                value={formData.accountHolderName}
                                isInvalid={!!errors.accountHolderName}
                                minLength={3}
                                maxLength={40} placeholder="Enter account holder name"
                                onChange={(e) => {
                                    const value = e.target.value;

                                    setFormData({
                                        ...formData,
                                        accountHolderName: value,
                                    });

                                    if (!value.trim()) {
                                        setErrors({
                                            ...errors,
                                            accountHolderName:
                                                "Please enter account holder name",
                                        });
                                    } else if (
                                        !/^[A-Za-z\s.]+$/.test(value)
                                    ) {
                                        setErrors({
                                            ...errors,
                                            accountHolderName:
                                                "Only letters are allowed",
                                        });
                                    } else {
                                        setErrors({
                                            ...errors,
                                            accountHolderName: "",
                                        });
                                    }
                                }}
                            />

                            <Form.Control.Feedback type="invalid">
                                {errors.accountHolderName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group className="mb-1 bam-field">
                            <Form.Label className="bam-label">
                                Bank Name
                            </Form.Label>
                            <Form.Control placeholder="Enter bank name"
                                className="bam-input"
                                value={formData.bankName}
                                isInvalid={!!errors.bankName}
                                maxLength={60}
                                onChange={(e) =>
                                    handleFieldChange(
                                        "bankName",
                                        e.target.value
                                    )
                                }
                            />

                            <Form.Control.Feedback type="invalid">
                                {errors.bankName}
                            </Form.Control.Feedback>
                        </Form.Group>

                        <div className="row">
                            <Form.Group className="mb-1 bam-field">
                                <Form.Label className="bam-label">
                                    Account Number
                                </Form.Label>
                                <Form.Control placeholder="Enter account number"
                                    className="bam-input bam-input--mono"
                                    value={formData.accountNumber}
                                    isInvalid={!!errors.accountNumber}
                                    maxLength={18}
                                    onChange={(e) =>
                                        handleFieldChange(
                                            "accountNumber",
                                            e.target.value.replace(/\D/g, "")
                                        )
                                    }
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.accountNumber}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-1 bam-field">
                                <Form.Label className="bam-label">
                                    IFSC Code
                                </Form.Label>
                                <Form.Control placeholder="Enter IFSC code"
                                    className="bam-input bam-input--mono"
                                    value={formData.ifscCode}
                                    isInvalid={!!errors.ifscCode}
                                    maxLength={11}
                                    onChange={(e) =>
                                        handleFieldChange(
                                            "ifscCode",
                                            e.target.value
                                                .toUpperCase()
                                                .replace(/[^A-Z0-9]/g, "")
                                        )
                                    }
                                />

                                <Form.Control.Feedback type="invalid">
                                    {errors.ifscCode}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </div>

                        <Form.Group className="mb-3 bam-field">
                            <Form.Label className="bam-label">
                                Account Type
                            </Form.Label>

                            <div className="d-grid gap-2" style={{ gridTemplateColumns: "1fr 1fr" }}>
                                {["Savings", "Current"].map((type) => (
                                    <button
                                        key={type}
                                        type="button"
                                        className={`bam-type-btn${formData.accountType === type ? " bam-type-btn--active" : ""}`}
                                        onClick={() =>
                                            setFormData({
                                                ...formData,
                                                accountType: type,
                                            })
                                        }
                                    >
                                        {type}
                                    </button>
                                ))}
                            </div>
                        </Form.Group>
                    </Modal.Body>

                    <Modal.Footer className="bam-footer d-flex flex-row ">
                        <Button
                            variant="secondary"
                            className="bam-btn bam-btn--cancel"
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </Button>

                        <Button
                            className="bam-btn bam-btn--save"
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>


    );
};

